import { createAction, props } from '@ngrx/store';

export const ustawWidocznoscWarstwy = createAction(
  '[Warstwy dodatkowe] Ustaw widocznosc warstwy',
  props<{
    uuid: string;
    widoczna: boolean;
  }>()
);

export const ustawWszystkieWidocznosci = createAction(
  '[Warstwy dodatkowe] Ustaw wszystkie widocznosci',
  props<{
    widocznosci: Record<string, boolean>;
  }>()
);

export const wyczyscWidocznosciWarstw = createAction(
  '[Warstwy dodatkowe] Wyczysc widocznosci warstw'
);
